const MuiListItem = {
	button: {
		"&:hover": {
			backgroundColor: "rgba(0, 0, 0, 0.04)",
		},
	},
};
export default MuiListItem;
